module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCond.9b57464.woff2";